module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"code":"Code","name":"Name"},"et":{"code":"Code","name":"Name"},"ru":{"code":"Code","name":"Name"}}')
  delete Component.options._Ctor
}
